import React from "react";
import "./css/general.scss";
import Routers from "./pages/Router";
import {RecoilRoot} from "recoil";
import {DjangoAuthContextProvider} from "./context/DjangoAuthContext";

function App() {
  return (
    <RecoilRoot>
        <DjangoAuthContextProvider>
            <Routers/>
        </DjangoAuthContextProvider>
    </RecoilRoot>
    
  );
}

export default App;
